<template>
	<div class="login-container d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-transparent ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingUp"
						>
							Sign up
						</button>
					</div>
				</div>
			</nav>
		</header>

		<section class="flex-shrink-0 container">
			<div class="form-signin card">
				<h5 class="text-center mb-3">Sign In</h5>
				<div class="form-group d-flex tab">
					<button
						type="button"
						class="btn btn-block "
						v-bind:class="{
							'btn-primary': activeTabEmail,
							'btn-outline-primary': activeTabPhone,
						}"
						@click="showViaEmail"
					>
						Login with Email
					</button>
					<button
						type="button"
						class="btn btn-block "
						v-bind:class="{
							'btn-primary': activeTabPhone,
							'btn-outline-primary': activeTabEmail,
						}"
						@click="showViaPhone"
					>
						Login with Phone
					</button>
				</div>
				<div class="alert-box-1 mb-4" v-if="showloginErr">
					<p>
						{{ errMsgLogin }}
						<a href="/#/signup" class="text-inherit">create a new account</a>
					</p>
				</div>
				<div v-if="activeTabEmail">
					<div class="form-group">
						<label for="exampleInputEmail1">Email address</label>
						<input
							type="text"
							@focus="emailFocus"
							v-model="userid"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
						/>
						<label class="text-center pt-3" v-if="showEmailValid"
							>Invalid Email</label
						>
					</div>
				</div>
				<div v-if="activeTabPhone">
					<div class="form-group">
						<label>PHONE NUMBER</label>
						<div class="input-group">
							<div class="input-group-prepend">
								<button
									class="btn btn-light dropdown-toggle"
									type="button"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									({{ countryCode }}) {{ countryName }}
								</button>
								<div class="dropdown-menu">
									<a
										class="dropdown-item"
										href="#"
										v-for="(countrycode, index) in countrycodes"
										:key="index"
										@click="onCountryCodeClicked(countrycode)"
									>
										({{ countrycode["country_code"] }})
										{{ countrycode["country_name"] }}</a
									>
								</div>
							</div>
							<input
								type="text"
								class="form-control"
								v-model="telephone"
								@focus="phoneFocus"
								aria-label="Text input with dropdown button"
							/>
							
						</div>
						<label class="text-center pt-3" v-if="showPhoneValid">Invalid Phone</label>
					</div>
				</div>
				<div class="form-group">
					<label>Password</label>
					<div class="input-group align-items-center" id="show_hide_password">
						<input
							class="form-control "
							:type="textInputType"
							@focus="passwordFocus"
							v-model="password"
						/>
						<div class="input-group-addon">
							<a
								><i
									class="fa fa-eye-slash"
									aria-hidden="true"
									@click="switchPasswordType"
								></i
							></a>
						</div>
					</div>
					<label class="text-center pt-3" v-if="showPasswordValid"
						>Password can't be blank</label
					>
				</div>
				<div class="pb-3">
					Forgot your password?
					<a href="/#/forgotpasswordemail" class="ml-2">{{
						getText("click_here_to_reset_text")
					}}</a>
				</div>

				<button
					class="btn btn-primary btn-block text-uppercase"
					v-on:click.stop.prevent="login"
				>
					Login
				</button>
				<label v-if="noService" class="text-center pt-3"
					>Sign In with Phone is not available please contact to Admin</label
				>
				<div class="or py-2">
					<hr />
					<span>OR</span>
				</div>
				<button
					class="btn btn-info btn-block text-uppercase d-flex align-items-center justify-content-center"
					@click="facebookLoginNotification"
				>
					<i class="fa fa-facebook-square  mr-2 "></i> Log in with facebook
				</button>
				<div class="text-center pt-3">
					New to Ibakatv? <a href="/#/signup">Sign up now</a>
				</div>
			</div>
			<p class="text-center text-white pt-4">Download App</p>
			<p class="text-center text-white">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>

		<footer class="footer mt-auto py-3">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}
.alert-box-cont {
	display: flex;
}
.ico-login-alert {
	display: flex;
	align-items: center;
	justify-content: center;
}
.alert-box-1 {
	background: #f6e3e4 0% 0% no-repeat padding-box;
	border-radius: 4px;
	padding: 8px;
}
.alert-box-1 p {
	text-align: left;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.6;
	position: relative;
	margin-bottom: 0px !important;
}
.text-inherit {
	text-decoration: underline;
	color: inherit;
}
.login-container .dropdown-menu {
	height: 10rem;
	overflow-x: hidden !important;
	overflow-y: scroll !important;
	min-width: 115px !important;
	width: 115px !important;
}

.disabled {
	pointer-events: none !important;
	background-color: #3a588a !important;
	border-color: #345488 !important;
	color: #f1f2f2 !important;
	opacity: inherit !important;
}
</style>

<script>
import CountryCodes from "@/assets/json/CountryCodes.json";
export default {
	name: "login",
	components: {},
	metaInfo: {
		title: "SIGN IN",
		meta: [
			{
				name: "description",
				content:
					"You can sign in to iBAKATV using your email, phone number, or Facebook. New to iBAKATV, Sign up now.",
			},
		],
	},
	watch: {
		telephone(newval, oldval) {
			if (newval.length > 11) {
				this.telephone = oldval;
			}
		},
	},
	created() {
		this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		if (this.$store.state.user.logedin == true) {
			this.$router.push("/home");
		}
		const config = this.$store.getters.getGlobalConfigs;
		var cont = CountryCodes.find((con) => {
			return con.country_name == config.country_code;
		});
		this.countryCode = cont.country_code;
		this.countryName = cont.country_name;
	},
	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		getText(val) {
			return this.$store.getters.getGlobalConfigs[val];
		},
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		showViaPhone() {
			this.activeTabEmail = false;
			this.activeTabPhone = true;
		},
		showViaEmail() {
			this.activeTabPhone = false;
			this.activeTabEmail = true;
		},
		gotoSingUp() {
			this.$router.push("/signup");
		},
		emailFocus() {
			this.showEmailValid = false;
		},
		phoneFocus() {
			this.showPhoneValid = false;
		},
		passwordFocus() {
			this.showPasswordValid = false;
		},
		ValidateEmail() {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (this.userid.match(mailformat)) {
				return true;
			} 
			
			else {
				this.showEmailValid = true;
				return false;
			}
		},
		ValidatePhone() {
			var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
			if (this.telephone.match(phoneno)) {
				return true;
			} else {
				this.showPhoneValid = true;
				return false;
			}
		},
		onCountryCodeClicked(countrycode) {
			this.countryCode = countrycode.country_code;
			this.countryName = countrycode.country_name;
		},
		ValidPassword() {
			if (this.password == "") {
				this.showPasswordValid = true;
				return false;
			} else {
				return true;
			}
		},
		switchPasswordType() {
			this.textInputType =
				this.textInputType == "password" ? "text" : "password";
		},
		facebookLoginNotification() {
			// this.$store.commit(
			// 	"setNotification",
			// 	"Facebook Login Feature Is Coming Soon"
			// );
			FB.login(
				(response) => {
					// handle the response
					const fbAccesToken = response.authResponse.accessToken;
					FB.api("/me", { fields: "email" }, (response) => {
						const fbEmail = response.email;
						var dataToSend = {
							token: fbAccesToken,
							provider: "facebook",
							email: fbEmail,
						};
						this.$store.commit("setLoader", true);
						this.$store
							.dispatch("socialLogin", dataToSend)
							.then((res) => {
								this.$store.dispatch("account").then((res) => {
									if (res) {
										this.accountData = res.response;
										if (this.accountData.profile.mobileVerified == false) {
											this.$store.commit(
												"setNotification",
												"Please Verify your Phone Number"
											);
										}
										if (this.accountData.subscriptions.length > 0 && this.accountData.subscriptions[0].package_id == this.getText('restriction_package')) {
											this.$store.commit("showSpecialPopUp", true);
										}
										if (this.accountData.subscriptions.length == 0) {
											this.$router.push("/packages");
										}
										
									}
								});
								this.$store.commit("setuserLoggedIn", true);
								this.$router.push("/home");
								this.$store.commit("setLoader", false);
							})
							.catch((err) => {
								this.$store.commit("setLoader", false);
								this.showloginErr = true;
								this.errMsgLogin = err.response.data.error.message;
								this.$store.commit("setNotification", this.errMsgLogin);
							});
					});
				},
				{ scope: "public_profile,email" }
			);
		},

		login(e) {
			this.isActive = true;
			this.showloginErr = false;

			if (this.doLogin) {
				if (this.activeTabPhone) {
					//  this.noService = true;
					// return false
					if (this.ValidatePhone() == true && this.ValidPassword() == true) {
						var dataToSend = {
							id: this.countryCode + this.telephone,
							password: this.password,
							type: "number",
						};
						this.$store.commit("setLoader", true);
						this.$store
							.dispatch("login", dataToSend)
							.then((res) => {
								this.$store.dispatch("account").then((res) => {
									if (res) {
										this.accountData = res.response;
										if (this.accountData.profile.mobileVerified == false) {
											this.$store.commit(
												"setNotification",
												"Please Verify your Phone Number"
											);
											return;
										}
										if (this.accountData.subscriptions.length > 0 && this.accountData.subscriptions[0].package_id == this.getText('restriction_package')) {
											this.$store.commit("showSpecialPopUp", true);
										}
										if (this.accountData.subscriptions.length == 0) {
											this.$router.push("/packages");
										}
									}
								});
								this.$store.commit("setuserLoggedIn", true);
								this.$router.push("/home");
								this.$store.commit("setLoader", false);
							})
							.catch((err) => {
								this.$store.commit("setLoader", false);
								this.showloginErr = true;
								this.errMsgLogin = err.response.data.error.message;
							});
					}
				} else {
					if (this.ValidateEmail() == true && this.ValidPassword() == true) {
						var dataToSend = {
							id: this.userid,
							password: this.password,
							type: "email",
						};
						this.$store.commit("setLoader", true);
						this.$store
							.dispatch("login", dataToSend)
							.then((res) => {
								this.$store.dispatch("account").then((res) => {
									if (res) {
										this.accountData = res.response;
										if (this.accountData.profile.emailVerified == false) {
											this.$store.commit(
												"setNotification",
												"Please Verify your Email Address"
											);

											return;
										}
										if (this.accountData.subscriptions.length > 0 && this.accountData.subscriptions[0].package_id == this.getText('restriction_package')) {
											this.$store.commit("showSpecialPopUp", true);
										}
										if (this.accountData.subscriptions.length == 0) {
											this.$router.push("/packages");
										}
									}
								});
								this.$store.commit("setuserLoggedIn", true);
								this.$router.push("/home");
								this.$store.commit("setLoader", false);
							})
							.catch((err) => {
								this.$store.commit("setLoader", false);
								this.showloginErr = true;
								this.errMsgLogin = err.response.data.error.message;
							});
					}
				}
			}
		},
	},

	data() {
		return {
			noService: false,
			activeTabEmail: true,
			textInputType: "password",
			activeTabPhone: false,
			showloginErr: false,
			isActive: false,
			doLogin: true,
			userid: "",
			telephone: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			showEmailValid: false,
			showEmailValidErr: "Invalid Email",
			showPhoneValid: false,
			showPhoneValidErr: "Invalid Phone",
			showPasswordValid: false,
			showPasswordValidErr: "Password can't be blank",
			countrycodes: CountryCodes,
			countryCode: "",
			countryName: "",
			errMsgLogin: "",
			accountData:null
		};
	},
};
</script>
